module.exports = __webpack_public_path__ + "media/images/questionnaires/favicon-f74b27dbfba7b86f5b053bcdcc048b48.png";